import React from "react";
import { CheckCircle, AlertTriangle, Loader2 } from "lucide-react";

const ProgressBar = ({
  progress = 0,
  status = "processing", // "processing", "success", "error"
  message = "",
  showPercentage = true,
  className = "",
}) => {
  const getStatusColor = () => {
    switch (status) {
      case "success":
        return "bg-green-500";
      case "error":
        return "bg-red-500";
      case "processing":
      default:
        return "bg-[#B8460E]";
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case "success":
        return <CheckCircle className="h-5 w-5 text-green-400" />;
      case "error":
        return <AlertTriangle className="h-5 w-5 text-red-400" />;
      case "processing":
      default:
        return <Loader2 className="h-5 w-5 text-[#B8460E] animate-spin" />;
    }
  };

  const clampedProgress = Math.max(0, Math.min(100, progress));

  return (
    <div className={`w-full ${className}`}>
      {/* Progress Header */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          {getStatusIcon()}
          <span className="text-sm font-medium text-white">
            {status === "processing" && "Importing Data..."}
            {status === "success" && "Import Complete"}
            {status === "error" && "Import Failed"}
          </span>
        </div>
        {showPercentage && (
          <span className="text-sm font-mono text-gray-300">
            {Math.round(clampedProgress)}%
          </span>
        )}
      </div>

      {/* Progress Bar Track */}
      <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden">
        {/* Progress Bar Fill */}
        <div
          className={`h-full transition-all duration-300 ease-out ${getStatusColor()}`}
          style={{ width: `${clampedProgress}%` }}
        >
          {status === "processing" && (
            <div className="h-full bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse" />
          )}
        </div>
      </div>

      {/* Progress Message */}
      {message && <div className="mt-2 text-xs text-gray-400">{message}</div>}
    </div>
  );
};

export default ProgressBar;
